var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{ref:"itemsParent",staticClass:"layout-items",attrs:{"mb-5":""}},_vm._l((_vm.items),function(item){return _c('v-col',{key:item.id,attrs:{"cols":_vm.cols,"sm":_vm.sm,"md":_vm.md,"lg":_vm.lg}},[_c(_vm.componentName,{tag:"component",attrs:{"item":item,"show-content-type":_vm.showContentType,"data-test-id":_vm.dataTestId}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }